import { ColorEnum } from '@enum/style/color.enum';

import { SelectStyleInterface } from './select-style.interface';

export const SelectDarkTheme: SelectStyleInterface = {
  applicationDropDown: {
    backgroundColor: ColorEnum.OuterSpace,
    backgroundActiveColor: ColorEnum.Black100,
    backgroundSelectedColor: ColorEnum.Black150,
    borderColor: ColorEnum.Black70,
    borderActiveColor: ColorEnum.Teal100,
    colorText: ColorEnum.Black3,
  },
};
